<template>
  <v-container class="px-0">
    <v-row v-show="documents.length > 0">
      <v-col :cols="12">
        <strong>{{ $t('texts.attachedFiles') }}</strong>
      </v-col>
    </v-row>

    <!-- Uploaded files -->
    <v-row
      v-show="documents.length > 0"
      row
      wrap
      v-for="(file, index) in documents"
      :key="index"
    >
      <v-col :cols="9">
        <v-text-field
          :label="$t('texts.filename')"
          :value="file.title"
          required
          hide-details
          disabled
        />
      </v-col>
      <v-col :cols="3">
        <v-btn icon :href="fileHost + file.path" target="_blank">
          <v-icon color="primary">visibility</v-icon>
        </v-btn>
        <v-btn icon @click.stop="removeDocument(index)">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Show file while uploading -->
    <v-row v-for="(file, index) in fileUpload[uploadType]" :key="index">
      <v-col :cols="9">
        <v-text-field :label="$t('texts.filename')" :value="file.name" required hide-details/>
      </v-col>
      <v-col :cols="3">
        <v-btn icon text :loading="true">
          <v-icon color="primary">
            cloud_upload
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Add new files -->
    <v-divider v-show="documents.length > 0"/>
    <v-row>
      <v-col :cols="12" :sm="9">
        <strong>{{ $t('texts.addNewFiles') }}</strong>
        <br>{{ $t('texts.addDocuments') }}
      </v-col>
      <v-col :cols="12" :sm="3">
        <label
          :for="uploadType"
          class="white--text v-btn primary px-2 v-size--default"
        >
          {{ $t('texts.selectFile') }}
        </label>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="12">
        <vue-upload-component
          :input-id="uploadType"
          :ref="uploadType"
          :headers="authHeader"
          v-model="fileUpload[uploadType]"
          :post-action="url"
          @input-file="inputFile"
          @input-filter="inputFilter"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueUploadComponent from 'vue-upload-component';
import { employeeResumeDocumentUrl, fileHost } from '@/config';

export default {
  components: {
    VueUploadComponent,
  },
  name: 'FileUpload',
  props: {
    documents: {
      type: Array,
    },
    uploadType: {
      type: String,
    },
  },
  data() {
    return {
      fileUpload: {},
      fileName: '',
      newDocuments: [],
      url: employeeResumeDocumentUrl,
      uploadAuto: true,
      fileHost,
      authHeader: {
        Authorization: `Bearer ${this.$auth.token()}`,
      },
    };
  },
  mounted() {
    this.$eventBus.$on('clear-file-upload', () => {
      if (this.$refs[this.uploadType]) {
        this.$refs[this.uploadType].clear();
      }
    });
  },
  methods: {
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        this.pushNewFileToDocuments(newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
        }
      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs[this.uploadType].active) {
          this.$refs[this.uploadType].active = true;
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(pdf|jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      // Create a blob field
      newFile.blob = '';
      const URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
      return true;
    },
    pushNewFileToDocuments(filepath) {
      this.documents.push({
        title: this.fileUpload[this.uploadType][0].name,
        description: '',
        path: filepath,
      });
      this.fileUpload[this.uploadType] = [];
      this.fileName = '';
      this.passDataToParent();
    },
    removeDocument(index) {
      this.documents.splice(index, 1);
      this.passDataToParent();
    },
    passDataToParent() {
      this.$emit('interface', JSON.parse(JSON.stringify(this.documents)));
    },
  },
};
</script>
